import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Message, Icon } from "semantic-ui-react";
import { PRODUCT_PATH } from "../../constants/paths";

const UpgradeMessage = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);

  const handleDismiss = () => {
    setVisible(false);
    sessionStorage.setItem('upgradeMessageDismissed', 'true');
  };

  React.useEffect(() => {
    const dismissed = sessionStorage.getItem('upgradeMessageDismissed');
    if (dismissed === 'true') {
      setVisible(false);
    }
  }, []);

  if (!visible) return null;

  return (
    <Message
      warning
      icon
      onDismiss={handleDismiss}
      style={{ 
        marginTop: "1em",
        marginBottom: "1em"
      }}
    >
      <Icon name="exclamation triangle" />
      <Message.Content>
        <Message.Header>Upgrade to Premium</Message.Header>
        <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
          Unlock unlimited collections, advanced analytics, and exclusive features with our premium accounts.
        </p>
        <Button 
          primary 
          size="small"
          onClick={() => navigate(PRODUCT_PATH)}
        >
          <Icon name="star" />
          View Premium Plans
        </Button>
      </Message.Content>
    </Message>
  );
};

export default UpgradeMessage;
